const BOOKING_ID_URL_PARAM = 'booking';
const FULFILLMENT_URL_PARAM = 'fulfillment';
const PASSENGER_EXTERNAL_REF_URL_PARAM = 'passengerExternalRefs';
const ORIGIN_STOP_REF_URL_PARAM = 'originStopPlaceRef';
const DESTINATION_STOP_REF_URL_PARAM = 'destinationStopPlaceRef';
const DEPARTURE_TIME_URL_PARAM = 'departureTime';
const TOKEN_URL_PARAM = 'exchangeToken';

export const JOURNEY_CHANGE_ROUTE = '/journey-change';

export const journeyChangePath = (
  search: string,
  step?: 'offer' | 'checkout'
): string => `${JOURNEY_CHANGE_ROUTE}${step ? `/${step}` : ''}${search}`;

export interface JourneyChangeUrlParams {
  booking?: string;
  fulfillment?: string;
  passengerExternalRef?: string;
  originStopPlaceRef?: string;
  destinationStopPlaceRef?: string;
  departureTime?: string;
  exchangeToken?: string;
}

const normalize = (value: string | null): string | undefined =>
  value?.trim() || undefined;

/**
 * Reads the journey change deep-link parameters (from a customer notification
 * email) out of a URL query string. Defaults to the current location so callers
 * can invoke it with no arguments; an explicit string is accepted for testing.
 *
 * The origin/destination/departure params describe the new trip to pre-search;
 * the rest identify what is being exchanged. `exchangeToken` is opaque — the
 * backend validates it against the fulfillment and passenger.
 */
export const parseJourneyChangeUrlParams = (
  search: string = window.location.search
): JourneyChangeUrlParams => {
  const searchParams = new URLSearchParams(search);
  return {
    booking: normalize(searchParams.get(BOOKING_ID_URL_PARAM)),
    fulfillment: normalize(searchParams.get(FULFILLMENT_URL_PARAM)),
    passengerExternalRef: normalize(
      searchParams.get(PASSENGER_EXTERNAL_REF_URL_PARAM)
    ),
    originStopPlaceRef: normalize(searchParams.get(ORIGIN_STOP_REF_URL_PARAM)),
    destinationStopPlaceRef: normalize(
      searchParams.get(DESTINATION_STOP_REF_URL_PARAM)
    ),
    departureTime: normalize(searchParams.get(DEPARTURE_TIME_URL_PARAM)),
    exchangeToken: normalize(searchParams.get(TOKEN_URL_PARAM)),
  };
};
